module.exports = __webpack_public_path__ + "static/JeremyZander2020.dcfeb034.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/images/JeremyZander2020.pdf
// module id = 326
// module chunks = 114276838955818